import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { Translatable } from './core/providers/translation/translation.model';

export class AppTranslationLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private url: string
  ) {}

  getTranslation(lang: string): Observable<Translatable> {
    return this.http.get(`${this.url}${lang}`).pipe(map((response) => this.keyAsTranslation(response)));
  }

  private keyAsTranslation(data: Translatable): Translatable {
    for (const key of Object.keys(data)) {
      if (typeof data[key] === 'object') {
        data[key] = this.keyAsTranslation(data[key] as Translatable);
      } else {
        data[key] = data[key] || key;
      }
    }

    return data;
  }
}

export const TranslateLoaderFactory = (http: HttpClient) => {
  let translationEndpoint: string = `${environment.services.translation}/translations/key-value/`;

  if (environment.services.translation.includes('localhost')) {
    const location = window.location;

    translationEndpoint = `${location.protocol}//${location.hostname}:4300/translations/`;
  }

  return new AppTranslationLoader(http, translationEndpoint);
};
